<template>
  <div id="Information" class="full_layout information" v-loading.fullscreen="loading">
    <h3 class="informationTitle">达咖资讯</h3>
    <ul class="informationList" v-if="list!=null">
      <li v-for="(item,index) in list" :key='index'>
        <router-link class="space_between" :to="{path:'/info/item/'+item._id+'?i='+index+'&p='+pi}">
          <div class="informationImg"><img :src="item.ImgUrl+'?imageView2/2/w/200'"></div>
          <div class="informationText">
            <div class="textTitle">{{item.Title}}</div>
            <p class="line_txt3">{{item.ContentText|setContent}}</p>
            <div class="textTime">{{item.ReleaseTime}}</div>
          </div>
        </router-link>
      </li>
    </ul>
    <pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex'  v-if="list!=null"/>
  </div>
</template>
<script>
import Pagination from '@/components/pagination'
export default {
  name: 'information',
  components: { Pagination },
  data() {
    return {
      ps: 24, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      loading: false,
      list: null,
    }
  },
  filters: {
    setContent(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\s+/g,'');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  mounted() {},
  created() {
    this.getRealtime();
  },
  methods: {
    getRealtime(){
      let that=this;
      that.loading=true;
      let data={PageIndex:that.pi,PageSize:that.ps}
      that.$get(that.$interface.Realtime,data).then(res=>{
        if(res.Result!=0){
          that.list=res.Data
        }
        that.loading=false;
      })
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getRealtime();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getRealtime();
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";

</style>



// WEBPACK FOOTER //
// src/pages/information/index.vue